import { Vector2 } from 'three'

/** Side elevation in inches: an upper vertical drop, long 45° descent, then a level bed return. */
export function facetedStairProfile(run: number, top: number, bedTop: number, tail = 5, thickness = 1.5) {
  // Extend the level top forward before a tall vertical transition into the descent.
  // Equal run and fall retain exact 45° turns into and out of the descent.
  const flat = Math.min(run - Math.min(0.5, run / 2), Math.max(run * 0.4, run - (top - bedTop) + 4))
  const diagonalTop = bedTop + run - flat
  const path = [new Vector2(0, top), new Vector2(flat, top),
    new Vector2(flat, diagonalTop), new Vector2(run, bedTop)]
  if (tail > 0) path.push(new Vector2(run + Math.max(0.5, tail), bedTop))
  // Intersect adjacent inward offsets: crisp miter joints, no overlapping cap blocks.
  const directions = path.slice(1).map((p,i)=>p.clone().sub(path[i]).normalize())
  const normals = directions.map(d=>new Vector2(d.y,-d.x).multiplyScalar(thickness))
  const inner = path.map((p,i)=>{
    if(i===0)return p.clone().add(normals[0])
    if(i===path.length-1)return p.clone().add(normals[i-1])
    const a=directions[i-1],b=directions[i],pa=p.clone().add(normals[i-1]),pb=p.clone().add(normals[i])
    const cross=a.x*b.y-a.y*b.x
    if(Math.abs(cross)<1e-8)return pa
    const delta=pb.sub(pa)
    return pa.addScaledVector(a,(delta.x*b.y-delta.y*b.x)/cross)
  })
  const sidePlane=(p:Vector2)=>new Vector2(-p.x,p.y)
  return {path, cap:[...path,...inner.slice().reverse()].map(sidePlane),
    cheek:[new Vector2(0,0),new Vector2(-path.at(-1)!.x,0),...inner.slice().reverse().map(sidePlane)]}
}

